import React from 'react'
import PropTypes from 'prop-types'
import { Flex, FormLabel, useFormControlContext } from '@chakra-ui/react'

export const FormLabelControl = React.forwardRef(({ label, hasValue, children, ...rest }, ref) => {
  const field = useFormControlContext()

  return (
    <Flex flex='1' position='relative'>
      {children({ field })}

      {label && (
        <FormLabel
          ref={ref}
          htmlFor={field?.name}
          pointerEvents='none'
          paddingX='0.125rem'
          position='absolute'
          top={`${field?.isFocused || hasValue ? '0.5rem' : '50%'}`}
          left='1rem'
          transform={`translateY(${field?.isFocused || hasValue ? '0%' : '-50%'})`}
          margin='0'
          fontSize={field?.isFocused || hasValue ? 'xs' : 'sm'}
          color={field?.isInvalid ? 'red.500' : field?.isFocused ? 'gray.800' : 'gray.600'}
          transition='all 0.1s ease-in-out'
          willChange='transform'
          {...rest}
        >
          {label}
        </FormLabel>
      )}
    </Flex>
  )
})

FormLabelControl.propTypes = {
  label: PropTypes.node,
  hasValue: PropTypes.bool.isRequired,
  children: PropTypes.func.isRequired,
}
